// src/utils/helpers.ts
export const convertTimestamp = (timestamp: any): Date => {
  if (!timestamp) return new Date();

  // If it's a Firestore Timestamp
  if (typeof timestamp === "object" && timestamp.toDate) {
    return timestamp.toDate();
  }

  // If it's already a Date object
  if (timestamp instanceof Date) {
    return timestamp;
  }

  // If it's a string or number
  return new Date(timestamp);
};
